import axios from "axios";
import { backendUrl } from "../../config/config";

const url = backendUrl + "/utils";

const siteStatus = async () => {
  try {
    const res = await axios.get(`${url}/site-status`);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

const answerWorked = async (data) => {
  try {
    const res = await axios.put(`${url}/answer-worked`, data);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

const doubtSolved = async (data) => {
  try {
    const res = await axios.put(`${url}/doubt-solved`, data);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

const likeDislike = async (data) => {
  try {
    const res = await axios.put(`${url}/like-dislike`, data);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

export {
  siteStatus,
  answerWorked,
  doubtSolved,
  likeDislike
};